var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kpi-strip" },
    _vm._l(_vm.kpis, function(kpi) {
      return _c(
        "div",
        {
          key: kpi.key,
          staticClass: "kpi-strip__card az-card-bordered az-gap-xsmall"
        },
        [
          _c("span", { staticClass: "az-text-small" }, [
            _vm._v(_vm._s(kpi.label))
          ]),
          _c(
            "span",
            {
              staticClass: "az-title-secondary",
              style: _vm.toneStyles[kpi.tone]
            },
            [_vm._v(" " + _vm._s(kpi.value) + " ")]
          ),
          _c(
            "span",
            { staticClass: "az-text-small", attrs: { "aria-live": "polite" } },
            [_vm._v(_vm._s(kpi.hint))]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }